export const LANGUAGES = {
    EN: 'English',
    DE: 'German',
    IT: 'Italian',
    FR: 'French',
};
